import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Checkbox from "@material-ui/core/Checkbox";
import { EnergyCalculationService } from '../../services/bunkermaster/EnergyCalculationService';
import TextField from '@material-ui/core/TextField';
import Energy_Switches from './energy-water-switch'
import { StyledTableCell, StyledTableRow, useStyles, BootstrapInput } from './assets/EnergyStyles'
import EnergyConversion from './EnergyConversation'
import { toast } from 'react-toastify';
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import HelpIcon from '@material-ui/icons/Help';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function ScrollDialog() {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);
}

function EnergyCalculation() {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [fieldValues, setFieldValues] = React.useState({ CalculateSpecificEnergy: "" })
    const [energy, setEnergy] = React.useState({ Gross: "", Net: "", NetASTM: "" })
    const [calcFields, setCalcFields] = React.useState({ calcmethod: "ISO 8217:2017", fueltype: "Residual", density: "", water: "", volume: true, ash: "", sulphur: "", GHC: "", hydrogen: "" })
    const [fieldClass, setFieldClass] = React.useState({ fueltype: true, density: true, water: true, ash: true, sulphur: true, GHC: true, hydrogen: true });
    const [info, setInfo] = React.useState({ density: true, water: true, ash: true, sulphur: true, hydrogen: true });
    const [selection, setSelection] = React.useState('');

    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState('paper');

    const handleClickOpen = (scrollType) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const Calculation = () => {
        
        if (calcFields.calcmethod === "ISO 8217:2017" || calcFields.calcmethod === "ISO 8217:2012" || calcFields.calcmethod === "ISO 8217:2010" || calcFields.calcmethod === "ISO 8217:2005" || calcFields.calcmethod === "ISO 8217:1996" || calcFields.calcmethod === "ASTM D4868") {
            if (calcFields["fueltype"] === "") {
                let update = fieldClass;
                update["fueltype"] = false;
                setFieldClass({ ...fieldClass, ...update });
            }
            if (calcFields["density"] === "") {
                let update = fieldClass;
                update["density"] = false;
                setFieldClass({ ...fieldClass, ...update });
            }
            if (calcFields["water"] === "") {
                let update = fieldClass;
                update["water"] = false;
                setFieldClass({ ...fieldClass, ...update });
            }
            if (calcFields["ash"] === "") {
                let update = fieldClass;
                update["ash"] = false;
                setFieldClass({ ...fieldClass, ...update });
            }
            if (calcFields["sulphur"] === "") {
                let update = fieldClass;
                update["sulphur"] = false;
                setFieldClass({ ...fieldClass, ...update });
            }
            if (calcFields["density"] !== "" && calcFields["water"] !== "" && calcFields["ash"] !== "" && calcFields["sulphur"] !== "") {
                if (calcFields["density"] >= 611.5 && calcFields["density"] <= 1163) {
                    if (calcFields["water"] >= 0 && calcFields["water"] <= 100) {
                        if (calcFields["ash"] >= 0 && calcFields["ash"] <= 100) {
                            if (calcFields["sulphur"] >= 0 && calcFields["sulphur"] <= 100) {
                                const { calcmethod, fueltype, density, volume, water, ash, sulphur, GHC, hydrogen } = calcFields
                                let result = EnergyCalculationService.calculate({
                                    calcmethod: calcmethod,
                                    fueltype: fueltype,
                                    DensityNumTextBox: density,
                                    VolumePctCheckBox: volume,
                                    WaterNumTextBox: water,
                                    AshNumTextBox: ash,
                                    SulphurNumTextBox: sulphur,
                                    GHC: GHC,
                                    hydrogen: hydrogen

                                })
                                setEnergy({ ...energy, ...{ Gross: result.GSETextBox ? result.GSETextBox : "", Net: result.NSETextBox ? result.NSETextBox : "" } })
                            } else {

                                setEnergy({ ...energy, ...{ Gross: "", Net: "" } })

                            }

                        } else {

                            setEnergy({ ...energy, ...{ Gross: "", Net: "" } })

                        }

                    } else {

                        setEnergy({ ...energy, ...{ Gross: "", Net: "" } })

                    }

                } else {

                    setEnergy({ ...energy, ...{ Gross: "", Net: "" } })

                }

            } else {

                setEnergy({ ...energy, ...{ Gross: "", Net: "" } })

            }

            /* else {
            const { calcmethod, fueltype, density, volume, water, ash, sulphur, GHC, hydrogen } = calcFields
            let result = EnergyCalculationService.calculate({
                calcmethod: calcmethod,
                fueltype: fueltype,
                DensityNumTextBox: density,
                VolumePctCheckBox: volume,
                WaterNumTextBox: water,
                AshNumTextBox: ash,
                SulphurNumTextBox: sulphur,
                GHC: GHC,
                hydrogen: hydrogen

            })
            ;

            setEnergy({ ...energy, ...{ Gross: result.GSETextBox ? result.GSETextBox : "", Net: result.NSETextBox ? result.NSETextBox : "" } })

        } */
        }


        else {
            if (calcFields["GHC"] === "") {
                let update = fieldClass;
                update["GHC"] = false;
                setFieldClass({ ...fieldClass, ...update });
            }
            if (calcFields["hydrogen"] === "") {
                let update = fieldClass;
                update["hydrogen"] = false;
                setFieldClass({ ...fieldClass, ...update });
            } if (calcFields["GHC"] !== "" && calcFields["hydrogen"] !== "") {
                if (calcFields["GHC"] >= 0) {
                    if (calcFields["hydrogen"] >= 0 && calcFields["hydrogen"] <= 100) {
                        const { calcmethod, fueltype, density, volume, water, ash, sulphur, GHC, hydrogen } = calcFields
                        let result = EnergyCalculationService.calculate({
                            calcmethod: calcmethod,
                            fueltype: fueltype,
                            DensityNumTextBox: density,
                            VolumePctCheckBox: volume,
                            WaterNumTextBox: water,
                            AshNumTextBox: ash,
                            SulphurNumTextBox: sulphur,
                            GHC: GHC,
                            hydrogen: hydrogen

                        })
                        setEnergy({ ...energy, ...{ NetASTM: result.NSETextBox ? result.NSETextBox : "" } })
                    } else {

                        setEnergy({ ...energy, ...{ NetASTM: "" } })

                    }

                } else {

                    setEnergy({ ...energy, ...{ NetASTM: "" } })

                }

            } else {

                setEnergy({ ...energy, ...{ NetASTM: "" } })

            }
            /* else {
                const { calcmethod, fueltype, density, volume, water, ash, sulphur, GHC, hydrogen } = calcFields
                let result = EnergyCalculationService.calculate({
                    calcmethod: calcmethod,
                    fueltype: fueltype,
                    DensityNumTextBox: density,
                    VolumePctCheckBox: volume,
                    WaterNumTextBox: water,
                    AshNumTextBox: ash,
                    SulphurNumTextBox: sulphur,
                    GHC: GHC,
                    hydrogen: hydrogen
    
                })
                ;
                
    
                    setEnergy({ ...energy, ...{ NetASTM: result.NSETextBox ? result.NSETextBox : "" } })
               
            } */
        }
    }



    const onResetenergy = (field) => {
        ;
        setInfo({...info,...{ density: true, water: true, ash: true, sulphur: true, hydrogen: true}})
        setEnergy({ ...energy, ...{ Gross: "", Net: "", NetASTM: "" } })
        setCalcFields({ ...calcFields, ...{ density: "", water: "", ash: "", sulphur: "", GHC: "", hydrogen: "" } })
    }
    const onValuesChange = (value, field) => {
        
        let local = calcFields;
        local[field] = value;
        setCalcFields({ ...calcFields, ...local });
        if (calcFields["fueltype"] !== "") {
            let update = fieldClass;
            update["fueltype"] = true;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["density"] !== "") {
            let update = fieldClass;
            update["density"] = true;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["water"] !== "") {
            let update = fieldClass;
            update["water"] = true;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["ash"] !== "") {
            let update = fieldClass;
            update["ash"] = true;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["sulphur"] !== "") {
            let update = fieldClass;
            update["sulphur"] = true;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["GHC"] !== "") {
            let update = fieldClass;
            update["GHC"] = true;
            setFieldClass({ ...fieldClass, ...update });
        }
        if (calcFields["hydrogen"] !== "") {
            let update = fieldClass;
            update["hydrogen"] = true;
            setFieldClass({ ...fieldClass, ...update });
        }

        if (field === "density" && calcFields["density"] >= 611.5 && calcFields["density"] <= 1163 || calcFields["density"] === "") {
            let newupdate = info;
            newupdate["density"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "density") {
            let newupdate = info;
            newupdate["density"] = false;
            setInfo({ ...info, ...newupdate });
        }
        if (field === "water" && calcFields["water"] >= 0 && calcFields["water"] <= 100) {
            let newupdate = info;
            newupdate["water"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "water") {
            let newupdate = info;
            newupdate["water"] = false;
            setInfo({ ...info, ...newupdate });
        }
        if (field === "ash" && calcFields["ash"] >= 0 && calcFields["ash"] <= 100) {
            let newupdate = info;
            newupdate["ash"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "ash") {
            let newupdate = info;
            newupdate["ash"] = false;
            setInfo({ ...info, ...newupdate });
        }
        if (field === "sulphur" && calcFields["sulphur"] >= 0 && calcFields["sulphur"] <= 100) {
            let newupdate = info;
            newupdate["sulphur"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "sulphur") {
            let newupdate = info;
            newupdate["sulphur"] = false;
            setInfo({ ...info, ...newupdate });
        }
        if (field === "hydrogen" && calcFields["hydrogen"] >= 0 && calcFields["hydrogen"] <= 100) {
            let newupdate = info;
            newupdate["hydrogen"] = true;
            setInfo({ ...info, ...newupdate });
        } else if (field === "hydrogen") {
            let newupdate = info;
            newupdate["hydrogen"] = false;
            setInfo({ ...info, ...newupdate });
        }

    }



    return (

        <div className={classes.root}>
            <div className="mar25">
                <div className="breadcurmbg mb25">
                    <span>Bunker Master </span>
                    <span className="bcarrow">  </span>
                    <span>Energy Calculation</span>

                </div>




                <AppBar position="static" className="custom-tabs">
                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                        <Tab label="Energy Calculation" {...a11yProps(0)} />
                        <Tab label="Energy Conversion" {...a11yProps(1)} />

                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0} className="custom-tab-section  ">

                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">Energy Calculation</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p>  This module performs standard Energy Calculations. The default method is ISO 8217:2010 (see example 1), but you can also use the equivalent methods ISO 8217:2005 , ISO 8217:1996 and ASTM D 4868.
                                            In addition, you can use the method ASTM D 240 to calculate the Net Heat of Combustion (see example 2).    </p>
                                        <p>    Please note that for methods ISO 8217:2010 and ISO 8217:2005, it is important to select the correct Fuel Product (Residual or Distilate fuel).</p>
                                        <p>It is also important to select the correct unit for the Water content. In most cases this will be in Volume percent (%V/V), but it may also be in Mass percent (%m/m).</p>
                                        <p className="subtitle"> Example 1 - Calculation of Specific Energy </p>
                                        <img className="maxwidth100" src="/assets/images/Energy-Calculation-1.jpg"></img>
                                        <p className="subtitle">Example 2 - Calculation of Net Heat of Combustion </p>
                                        <img className="maxwidth100" src="/assets/images/Energy-Calculation-2.jpg"></img>
                                        

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>

                        <FormControl component="fieldset" className="fullwidth custom-style1">
                            <p className="subtitle">Calculation Method</p>
                            <RadioGroup row aria-label="position" onChange={(e) => onValuesChange(e.target.value, "calcmethod")} name="position" defaultValue="top">

                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={3} className="energyb1">
                                        <FormControlLabel className="cust-label1" value="ISO 8217:2017" control={<Radio />} label="ISO 8217:2017" checked={!calcFields.calcmethod ? true : calcFields.calcmethod === "ISO 8217:2017" ? true : false} />
                                        <FormControlLabel className="cust-label1" value="ISO 8217:2012" control={<Radio />} label="ISO 8217:2012" />
                                        <FormControlLabel className="cust-label1" value="ISO 8217:2010" control={<Radio />} label="ISO 8217:2010" />
                                        <FormControlLabel className="cust-label1" value="ISO 8217:2005" control={<Radio />} label="ISO 8217:2005" />
                                        <FormControlLabel className="cust-label1" value="ISO 8217:1996" control={<Radio />} label="ISO 8217:1996" />
                                    </Grid>
                                    <Grid item xs={12} md={5} className="energyb1">



                                        <FormControlLabel className="cust-label1" value="ASTM D4868" control={<Radio />} label="ASTM D4868" />
                                        <FormControlLabel className="cust-label1" value="ASTM D240" control={<Radio />} label="ASTM D240" />
                                    </Grid>
                                </Grid>

                            </RadioGroup>
                            <br></br>
                        </FormControl>

                    </Box>


                    {calcFields.calcmethod === "ISO 8217:2017" || calcFields.calcmethod === "ISO 8217:2012" || calcFields.calcmethod === "ISO 8217:2010" || calcFields.calcmethod === "ISO 8217:2005" || calcFields.calcmethod === "ISO 8217:1996" || calcFields.calcmethod === "ASTM D4868" ? <Grid container spacing={3}  >
                        <Grid item xs={12} md={7} className="energyb1">
                            <Box component="div" className="bunkarinput bunkerinput-md" style={{ display: calcFields.calcmethod === "ISO 8217:1996" || calcFields.calcmethod === "ASTM D4868" ? 'none' : 'block' }}>
                                <FormControl component="fieldset">
                                    <RadioGroup row aria-label="position" name="position" defaultValue="top" value={calcFields.fueltype}>

                                        <label className="pr30"> Full Product Type  <span className="redstar">*</span> <span className={fieldClass.fueltype ? "userinfo" : "errortext"}>Select Product Type !</span>  </label>
                                        <FormControlLabel value="Residual" onChange={(e) => onValuesChange(e.target.value, "fueltype")} control={<Radio />} label="Residual" />
                                        <FormControlLabel value="Distillate" onChange={(e) => onValuesChange(e.target.value, "fueltype")} control={<Radio />} label="Distillate" />

                                    </RadioGroup>
                                </FormControl>
                            </Box>
                            <Box component="div" className="bunkarinput">
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={3} className="padbtm0">
                                        <label for="Density"> Density at 15<sup>o</sup>C  <span className="redstar">*</span> </label>
                                    </Grid>
                                    <Grid item xs={12} md={7} className="padbtm0">
                                        <BootstrapInput
                                            className={fieldClass["density"] ? "mt0" : "error"}
                                            onChange={(e) => onValuesChange(e.target.value, "density")}
                                            value={calcFields.density}
                                            type="number" /> Kg/m3

                                        <span className={fieldClass.density ? "userinfo" : "errortext"}>Density is required.</span>
                                        <span className={info.density ? "info" : "errortext"} >Density must be a numeric value between 611.5 and 1163 kg/m3</span>
                                    </Grid></Grid>
                            </Box>

                            <Box component="div" className="bunkarinput">
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={3} className="padbtm0">
                                        <label className="waterblock"  > Water  <span className="redstar">*</span>
                                        </label>
                                    </Grid>
                                    <Grid item xs={12} md={9} className="padbtm0 energywater">
                                        <BootstrapInput
                                            type="number"
                                            className={fieldClass["water"] ? "mt0" : "error"}
                                            onChange={(e) => onValuesChange(e.target.value, "water")}
                                            value={calcFields.water} />
                                        <Energy_Switches checked={calcFields.volume} prefix={"%m/m"}
                                            suffix={"%V/V"} className="widthauto" onChange={(e) => { setCalcFields({ ...calcFields, ...{ volume: e.target.checked } }) }} />
                                        <span className={fieldClass.water ? "userinfo" : "errortext"}> Water is required.</span>
                                        <span className={info.water ? "info" : "errortext"}>Water must be a numeric value between 0 and 100</span>
                                    </Grid>
                                </Grid>
                            </Box>

                            <Box component="div" className="bunkarinput">
                                <Grid container spacing={3} >
                                    <Grid item xs={12} md={3} className="padbtm0">
                                        <label>Ash content <span className="redstar">*</span> </label>
                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">
                                        <BootstrapInput type="number" className={fieldClass["ash"] ? "mt0" : "error"} required onChange={(e) => onValuesChange(e.target.value, "ash")} value={calcFields.ash} /> %m/m
                                        <span className={fieldClass.ash ? "userinfo" : "errortext"}> Ash content is required.</span>
                                        <span className={info.ash ? "info" : "errortext"}>Ash must be a numeric value between 0 and 100</span>
                                    </Grid></Grid>

                            </Box>

                            <Box component="div" className="bunkarinput">
                                <Grid container spacing={3}  >
                                    <Grid item xs={12} md={3} className="padbtm0">
                                        <label>Sulphur content <span className="redstar">*</span> </label>
                                    </Grid>
                                    <Grid item xs={12} md={6} className="padbtm0">
                                        <BootstrapInput type="number" className={fieldClass["sulphur"] ? "mt0" : "error"} onChange={(e) => onValuesChange(e.target.value, "sulphur")} value={calcFields.sulphur} />  %m/m
                                        <span className={fieldClass.sulphur ? "userinfo" : "errortext"}> Sulphur content is required.</span>
                                        <span className={info.sulphur ? "info" : "errortext"}>Sulphur must be a numeric value between 0 and 100</span>
                                    </Grid>
                                </Grid>
                            </Box>



                        </Grid>
                        <Grid item xs={12} md={5}>
                            <Box component="div" className="resultbox">
                                <p>Results</p>
                                <Box component="div" className="bunkarinput resultinner">

                                    <form className={classes.root} noValidate autoComplete="off">
                                        <Box component="div" className="padbtm25" style={{ display: calcFields.calcmethod === "ISO 8217:2005" && calcFields.fueltype === "Distillate" ? 'none' : 'block' }}>
                                            <label className="resultLabel"> Gross Specific Energy  </label>
                                            <TextField id="standard-basic" value={energy.Gross} />
                                            <span className="resultmv"> MJ/Kg</span>

                                        </Box>
                                        <Box component="div" className=" ">
                                            <label className="resultLabel">  Net Specific Energy </label>
                                            <TextField id="standard-basic" value={energy.Net} />
                                            <span className="resultmv"> MJ/Kg</span>

                                        </Box>
                                    </form>
                                </Box>



                            </Box>

                        </Grid>

                        <Grid item xs={12} md={12}>
                            <button type="reset" className={classes.btn1} onClick={onResetenergy} >Reset</button>
                            <button type="button" className={classes.btn2} onClick={Calculation} >Calculate</button>{''}

                        </Grid>
                        {calcFields.calcmethod === "ISO 8217:2005" || calcFields.calcmethod === "ISO 8217:1996" ? <div className="warningtxt">"Note: This method has been replaced by ISO 8217:2010"</div> : calcFields.calcmethod === "ASTM D4868" ? <div className="warningtxt">"Note: This method is equivalent to the BSMA 100:1982 method"</div> : ""}
                    </Grid> :
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={7} className="energyb1">

                                <Box component="div" className="bunkarinput">
                                    <Grid container spacing={3}  >
                                        <Grid item xs={12} md={3} className="padbtm0">
                                            <label> Gross Heat of Combustion  <span className="redstar">*</span> </label>
                                        </Grid>
                                        <Grid item xs={12} md={6} className="padbtm0">
                                            <BootstrapInput type="number" className={fieldClass["GHC"] ? "mt0" : "error"} onChange={(e) => onValuesChange(e.target.value, "GHC")} value={calcFields.GHC} /> MJ/kg
                                            <span className={fieldClass.GHC ? "userinfo" : "errortext"}>  Gross Heat of Combustion is required.</span>
                                        </Grid>
                                    </Grid>
                                </Box>

                                <Box component="div" className="bunkarinput">
                                    <Grid container spacing={3}  >
                                        <Grid item xs={12} md={3} className="padbtm0">
                                            <label>Hydrogen
                                                {/* <FormControlLabel
                                                    control={<Checkbox  name="checkedA" />}
                                                    label="%V/V"
                                                    color="primary"
                                                    className="insidelabel pdl20"
                                                    onChange={handleChange}
                                                /> */}
                                            </label> </Grid>
                                        <Grid item xs={12} md={6} className="padbtm0">


                                            <BootstrapInput type="number" className={fieldClass["hydrogen"] ? "mt0" : "error"} onChange={(e) => onValuesChange(e.target.value, "hydrogen")} value={calcFields.hydrogen} /> %m/m
                                            <span className={fieldClass.hydrogen ? "userinfo" : "errortext"}>  Hydrogen  is required.</span>
                                            <span className={info.hydrogen ? "info" : "errortext"}>hydrogen must be a numeric value between 0 and 100</span>
                                        </Grid></Grid>
                                </Box>




                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Box component="div" className="resultbox">
                                    <p>Results</p>
                                    <Box component="div" className="bunkarinput resultinner">

                                        <form className={classes.root} noValidate autoComplete="off">
                                            <Box component="div" className="padbtm25">
                                                <label className="resultLabel"> Net Heat of Combustion </label>
                                                <TextField id="standard-basic" value={calcFields.calcmethod === "ASTM D240" ? energy.NetASTM : ""} />
                                                <span className="resultmv"> MJ/Kg</span>

                                            </Box>

                                        </form>
                                    </Box>



                                </Box>

                            </Grid>

                            <Grid item xs={12} md={12}>
                                <button type="reset"
                                    className={classes.btn1}
                                    onClick={onResetenergy}>Reset</button>

                                <button type="button" className={classes.btn2} onClick={Calculation} >Calculate</button>{''}

                            </Grid>
                        </Grid>
                    }

                </TabPanel>
                <TabPanel value={value} index={1} className="custom-tab-section">
                    <Box component="div" className="pos_relative">
                        <Box component="div" className="help_blk">
                            <Button onClick={handleClickOpen('paper')}> <HelpIcon /></Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                scroll={scroll}
                                aria-labelledby="scroll-dialog-title"
                                aria-describedby="scroll-dialog-description"
                            >
                                <DialogTitle id="scroll-dialog-title">Energy Conversion</DialogTitle>
                                <DialogContent dividers={scroll === 'paper'}>
                                    <DialogContentText
                                        id="scroll-dialog-description"
                                        ref={descriptionElementRef}
                                        tabIndex={-1}
                                    >
                                        <p> This module performs standard Energy Conversion. Energy values can be converted between Energy in :
                                            Mg/Kg, Btu/Lb, Btu/barrel, Btu/gallon, Kcal/kg. </p>

                                        <p className="subtitle">Example </p>
                                        <img className="maxwidth100" src="/assets/images/Energy-Calculation-3.jpg"></img>
                                        

                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleClose}>Close</Button>
                                </DialogActions>
                            </Dialog>
                        </Box>
                    </Box>
                    <EnergyConversion />
                </TabPanel>
            </div>
        </div>
    );
}
export default EnergyCalculation;
